import { error } from '@utils/logger'
import { apiFetch } from '@utils/fetch'

export interface SyncShortcodesResponse {
  status: string
  message: string
}

export interface GetShortcodesResponse {
  short_codes: Record<string, string>
}

export async function syncShortcodes(): Promise<SyncShortcodesResponse | null> {
  try {
    const resp = await apiFetch('/api/admin/shortcodes/sync', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!resp.ok) {
      error('failed to sync shortcodes', resp.statusText)
      return null
    }

    const data = await resp.json()
    return data as SyncShortcodesResponse
  } catch (err) {
    error('failed to sync shortcodes', err)
    return null
  }
}

export async function getShortcodes(): Promise<GetShortcodesResponse | null> {
  try {
    const resp = await apiFetch('/api/admin/shortcodes', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!resp.ok) {
      error('failed to get shortcodes', resp.statusText)
      return null
    }

    const data = await resp.json()
    return data as GetShortcodesResponse
  } catch (err) {
    error('failed to get shortcodes', err)
    return null
  }
}

export default { syncShortcodes, getShortcodes }